import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { LeaderboardPeriodTypesEnum } from '../../enums';
import { Transform } from 'class-transformer';
import { dateStringToDate, dateStringToDateOptional } from '../../types-transformers';

export class LeaderboardFilter extends PaginationFilter {

	/**
	 * @summary Depends on period.
	 *
	 * For monthly leaderboard should be set to the beginning of the month. For yearly - beginning of the year.
	 *
	 * If set to any other date except for period beginning, backend anyway normalizes it
	 */
	@Transform(dateStringToDate)
	public periodStart: Date;

	/**
	 * @summary Can be used to show partial leaderboard limited with some specific date/time.
	 */
	@Transform(dateStringToDateOptional)
	public periodEnd?: Date;

	public periodType: LeaderboardPeriodTypesEnum = LeaderboardPeriodTypesEnum.Month;

	public interestsIds?: string[];
	public excludedInterestsIds?: string[];
}
